import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-tooltip-page-ui',
    templateUrl: './bb-tooltip-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TooltipPageComponent {}
